var dataAccessPayment = document.querySelector(
    "button[data-access-payment-function]"
);
var greenTextUpdate = document.querySelector("p[data-greentext-updated]");
dataAccessPayment?.addEventListener("click", function () {
    greenTextUpdate.innerText = "Data access";
});

// slider range //
(function () {
    $(".progress-range").slider({
        range: "min",
        min: 0,
        max: 100,
        value: 50,
    });

    let $dropTickLi = $(".drop-tick li:not(.notick)");

    $dropTickLi.on("click", markActive);
    $dropTickLi.first().trigger("click");
    let $dropTickSingleLi = $(".drop-tick-single-level li");

    $dropTickSingleLi.on("click", function () {
        var add_class = true;
        if ($(this).find("a").hasClass("active")) {
            add_class = false;
        }
        $(this).parent().find("li").removeClass("tick_active");
        $(this).parent().find("li a").removeClass("active");
        if (add_class) {
            $(this).find("a").addClass("active");
        } else {
            $(this).find("a").removeClass("active");
        }
    });

    const downloadFormat = new MultiSelectList("#multi-select-download-format");
    downloadFormat.init();

    $(".tab-block-slider .nav-link").on("click", function () {
        $(".tab-block-slider").find(".nav-link").removeClass("active");
        $(this).addClass("active");
    });

    function markActive(e) {
        let $this = $(this),
            $dropTick = $this.closest(".drop-tick"),
            $dropTickImg = $dropTick.find("button p img");

        if ($this.hasClass("tick_active")) {
            $dropTick.find("li").removeClass("tick_active");
            if ($this.hasClass("main-select")) {
                let parent = $this.parents(".menu-list");
                let main_parent = parent.parents(".right-part");
                let title = main_parent
                    .find(".selector-parent")
                    .data("default-text");
                let logo = main_parent
                    .find(".selector-parent")
                    .data("default-image");
                main_parent.find(".owner").addClass("tick_active");
                main_parent
                    .find(".selector-parent")
                    .removeClass("parent-selected")
                    .html(
                        '<img class="icon-set-left" src="' + logo + '">' + title
                    );
            }
        } else {
            $dropTick.parents("ul").find("li").removeClass("tick_active");

            $html = $this
                .find(".drop-list-text")
                .html()
                .trim()
                .replace("me-1 align-icon-center", "icon-set-left");

            if ($this.hasClass("main-select")) {
                let parent = $this.parents(".menu-list");
                let main_parent = parent.parents(".right-part");
                if ($this.hasClass("owner")) {
                    main_parent
                        .find(".selector-parent")
                        .removeClass("parent-selected")
                        .html(
                            '<img class="icon-set-left" src="images/a-owner-original.svg">I am a home owner'
                        );
                } else {
                    let logo = $this.find("img").attr("src");
                    let child_title = $this.find(".list-text").text();
                    let parent_title = parent
                        .find(".main-text-list")
                        .text()
                        .trim();
                    main_parent
                        .find(".selector-parent")
                        .addClass("parent-selected")
                        .html(
                            `<img class="icon-set-left" src="${logo}">${parent_title}: ${child_title} `
                        );
                }
            }

            $dropTick.find("button p").html($html);
            $this.addClass("tick_active");
        }
    }

    let $dropdownSubMenu = $(".dropdown-submenu");

    $dropdownSubMenu.on("mouseenter", function () {
        $(this).parent().addClass("active_state");
    });

    $dropdownSubMenu.on("mouseleave", function () {
        $(this).parent().removeClass("active_state");
    });
}).call(this);

//focus-removed//
$(".dropdown").on("hide.bs.dropdown", function (e) {
    const input = $(".focus-btn");
    input.blur();
});
$(".menu-dropdown").on("hide.bs.dropdown", function (e) {
    const input = $(".focus-btn");
    input.blur();
});
$(".custom-focus .btn").on("click", function (e) {
    if ($(this).is(":focus")) {
        $(this).toggleClass("focus-btn-default");
        $(this).blur();
    }
});
$(".custom-focus a").on("click", function (e) {
    if ($(this).is(":focus")) {
        $(this).toggleClass("focus-btn-default");
        $(this).blur();
    }
});

// multi-click-chips
$(".chip-info").on("show.bs.dropdown", function () {
    $(this).parents("button").addClass("active");
});

$(".chip-info").on("hide.bs.dropdown", function () {
    $(this).parents("button").removeClass("active");
});

$(".multi-click button").on("click", function () {
    if ($(this).is(":focus")) {
        $(this).toggleClass("focus-active");
    }
});

$(document).ready(function () {
    $("input[type=number].xl-dynamic_percentage_width").on(
        "input",
        function (ev) {
            var $this = $(this);
            if ($this.val() > parseInt($(this).attr("max"))) {
                $this.val($(this).attr("max"));
            }
            var size = $this.val().length;
            var one_count = $this.val().split("1").length - 1;
            size = size * 9.5;
            if (one_count > 0) {
                size = size - one_count * 4.5;
            }
            $this.width(size);
        }
    );

    $(document)
        .find("input[type=number].xl-dynamic_percentage_width")
        .each(function () {
            var $this = $(this);
            if ($this.val() > parseInt($(this).attr("max"))) {
                $this.val($(this).attr("max"));
            }
            var size = $this.val().length;
            var one_count = $this.val().split("1").length - 1;
            size = size * 9.5;
            if (one_count > 0) {
                size = size - one_count * 4.5;
            }
            $this.width(size);
        });

    $(document)
        .find("input[type=number].xs-dynamic-number-value")
        .on("input", function (ev) {
            var $this = $(this);
            if ($this.val() > parseInt($(this).attr("max"))) {
                $this.val($(this).attr("max"));
            }
            var size = $this.val().length;
            var one_count = $this.val().split("1").length - 1;
            size = size * 8;
            if (one_count > 0) {
                size = size - one_count * 3.5;
            }
            $this.width(size);
        });

    $(".energy-graph").on("click", function () {
        $(".energy-graph").removeClass("active");
        $(this).addClass("active");
    });

    $(document).on("click", function (e, f) {
        let $target = $(e.target);

        if (
            $target.hasClass("energy-graph") ||
            $target.closest(".energy-graph").length
        ) {
            return;
        }

        $(".energy-graph").not(".permanent-active").removeClass("active");
    });

    $(".element-section").on("click", function () {
        $(this).removeClass("active");
    });
});

$(document).ready(function () {
    $("input[type=number].xl-dynamic_percentage_residential_width").on(
        "input",
        function (ev) {
            var $this = $(this);
            if ($this.val() > parseInt($(this).attr("max"))) {
                $this.val($(this).attr("max"));
            }
            var size = $this.val().length;
            var one_count = $this.val().split("1").length - 1;
            size = size * 10.7;
            if (one_count > 0) {
                size = size - one_count * 8;
            }
            $this.width(size);
        }
    );

    $(document)
        .find("input[type=number].xl-dynamic_percentage_residential_width")
        .each(function () {
            var $this = $(this);
            if ($this.val() > parseInt($(this).attr("max"))) {
                $this.val($(this).attr("max"));
            }
            var size = $this.val().length;
            var one_count = $this.val().split("1").length - 1;
            size = size * 8.8;
            if (one_count > 0) {
                size = size - one_count * 8;
            }
            $this.width(size);
        });
});

$(document).ready(function () {
    $("input[type=number].xl-dynamic_percentage_transportation_width").on(
        "input",
        function (ev) {
            var $this = $(this);
            if ($this.val() > parseInt($(this).attr("max"))) {
                $this.val($(this).attr("max"));
            }
            var size = $this.val().length;
            var one_count = $this.val().split("1").length - 1;
            size = size * 10.7;
            if (one_count > 0) {
                size = size - one_count * 9;
            }
            $this.width(size);
        }
    );

    $(document)
        .find("input[type=number].xl-dynamic_percentage_transportation_width")
        .each(function () {
            var $this = $(this);
            if ($this.val() > parseInt($(this).attr("max"))) {
                $this.val($(this).attr("max"));
            }
            var size = $this.val().length;
            var one_count = $this.val().split("1").length - 1;
            size = size * 10.8;
            if (one_count > 0) {
                size = size - one_count * 9;
            }
            $this.width(size);
        });
});

$(document).ready(function () {
    $("input[type=number].input-lg-fields").on("input", function (ev) {
        var $this = $(this);
        if ($this.val() > parseInt($(this).attr("max"))) {
            $this.val($(this).attr("max"));
        }
        var size = $this.val().length;
        var one_count = $this.val().split("1").length - 1;
        size = size * 10;
        if (one_count > 0) {
            size = size - one_count * 8.5;
        }
        $this.width(size);
    });

    $(document)
        .find("input[type=number].input-lg-fields")
        .each(function () {
            var $this = $(this);
            if ($this.val() > parseInt($(this).attr("max"))) {
                $this.val($(this).attr("max"));
            }
            var size = $this.val().length;
            var one_count = $this.val().split("1").length - 1;
            size = size * 10;
            if (one_count > 0) {
                size = size - one_count * 8;
            }
            $this.width(size);
        });
});

$(function () {
    let $advanceSearchInput = $(".advanced-search-input"),
        $baseImage = $(".search-base-image"),
        $activeImage = $(".search-active-image");

    $advanceSearchInput
        .on("mouseover focus", function () {
            $baseImage.css("display", "none");
            $activeImage.css("display", "block");
        })
        .on("mouseout blur", function () {
            if (!$advanceSearchInput.is(":focus")) {
                $baseImage.css("display", "block");
                $activeImage.css("display", "none");
            }
        });
});

// link hover //

$(function () {
    $(".style-head")
        .mouseenter(function () {
            $(".primary-check-input").addClass("hover_remover");
        })
        .mouseleave(function () {
            $(".primary-check-input").removeClass("hover_remover");
        });
});

// li-active //

// Default slider range
const rangeInputs = document.querySelectorAll('input[type="range"]');
const numberInput = document.querySelector('input[type="number"]');

function handleInputChange(e) {
    let target = e.target;
    if (e.target.type !== "range") {
        target = document.getElementById("range");
    }
    const min = target.min;
    const max = target.max;
    const val = target.value;

    target.style.backgroundSize = ((val - min) * 100) / (max - min) + "% 100%";
}

rangeInputs.forEach((input) => {
    input.addEventListener("input", handleInputChange);
});

numberInput?.addEventListener("input", handleInputChange);

// Default slider range end

// Timeframe script
$(function () {
    const datepickers = $(".date-range-input");
    for (i = 0; i <= datepickers.length; i++) {
        $(datepickers[i]).daterangepicker(
            {
                autoApply: true,
                opens: "center",
            },
            function (start, end, label) {
                // $(".timeframe-info #startDate").val(start.format("MM/DD/YYYY"));
                // $(".timeframe-info #startDate").val(end.format("MM/DD/YYYY"));
            }
        );
    }
});
// Timeframe script end

// Account Card swap Start
$(".login-blue").on("click", function (e) {
    if ($("#loginSidebar").is(":visible")) {
        $("#loginSidebar").offcanvas("hide");
        $("#signupDrawer").offcanvas("show");
    }
    e.preventDefault();
});

$(".create-button").on("click", function (e) {
    if ($("#signupDrawer").is(":visible")) {
        $("#signupDrawer").offcanvas("hide");
        $("#loginSidebar").offcanvas("show");
    }
    e.preventDefault();
});

// Account Card swap start
$(document).on("click", function (e) {
    //compare element
    if ($(e.target).is("svg") === false && $(e.target).is("path") === false) {
        $(".tip").css("display", "none");
    }

    if (
        $(e.target).is("svg") === false &&
        $(e.target).is("path") === false &&
        $(e.target).is("p.text-base.font-bold") === false &&
        $(e.target).is("div.d-flex.bottom-center-tooltip.white-tooltip") ===
            false
    ) {
        $(".info-tip").addClass("d-none");
        $(".info-tooltipbtn").removeClass("activated");
        $(".tooltip2 .info").removeClass("active-state");
    } else if (
        $(e.target).is("p.text-base.font-bold") === true ||
        $(e.target).is("div.d-flex.bottom-center-tooltip.white-tooltip") ===
            true
    ) {
        $(e.target).closest(".info").find(".info-tooltipbtn").focus();
    }
});

// Climate Solution Multistep
var ClimateSolution = {
    totalSteps: 3,
    currentStep: 1,
    previousButton: null,
    nextButton: null,

    init: function () {
        this.previousButton = document.getElementById(
            "climate-solution-previous-btn"
        );

        //remove flex class from previous button
        this.previousButton?.classList.remove("d-flex");
        this.previousButton?.classList.add("d-none");

        //hide previous button
        // this.previousButton.style.display = 'none';

        $(".solution-left .progress-items button");
        this.addEvents();
        $("#marketplace-description-block").hide();
        $("#market-title-block").hide();
        $("#description-empty-block").show();
        $("#dummy-title-block").show();
        $("#marketplace-icon-block").hide();
        $("#dummy-icon-block").show();
    },

    addEvents: function () {
        this.nextButton = document.getElementById("climate-solution-next-btn");
        this.nextButton?.addEventListener("click", () => {
            this.nextStep();
        });

        this.previousButton?.addEventListener("click", () => {
            this.previousStep();
        });
    },

    nextStep: function () {
        switch (this.currentStep) {
            case 1:
                $("#form-section-1 button")
                    .removeClass("active")
                    .addClass("done");
                $("#form-section-1 button div").addClass("active");
                $("#form-section-2 button").addClass("active");

                this.previousButton.classList.add("d-flex");
                this.previousButton.classList.remove("d-none");
                this.currentStep = 2;
                this.activeTab();
                this.setButtonText();
                $("#marketplace-description-block").hide();
                $("#description-empty-block").show();
                $("#market-title-block").hide();
                $("#dummy-title-block").show();
                $("#marketplace-icon-block").hide();
                $("#dummy-icon-block").show();
                break;
            case 2:
                $("#form-section-2 button")
                    .removeClass("active")
                    .addClass("done");
                $("#form-section-2 button div").addClass("active");
                $("#form-section-3 button").addClass("active");

                this.currentStep = 3;
                this.activeTab();
                this.setButtonText();
                $("#marketplace-description-block").show();
                $("#description-empty-block").hide();
                $("#market-title-block").show();
                $("#dummy-title-block").hide();
                $("#marketplace-icon-block").show();
                $("#dummy-icon-block").hide();
                break;
            case 3:
                this.showCheckoutDrawer();
                break;
            default:
                break;
        }
    },

    previousStep: function () {
        switch (this.currentStep) {
            case 2:
                $("#form-section-2 button").removeClass("active");
                $("#form-section-1 button div").removeClass("active");
                $("#form-section-1 button")
                    .addClass("active")
                    .removeClass("done");

                this.previousButton.classList.remove("d-flex");
                this.previousButton.classList.add("d-none");
                this.currentStep = 1;
                this.activeTab();
                this.setButtonText();
                $("#marketplace-description-block").hide();
                $("#description-empty-block").show();
                $("#market-title-block").hide();
                $("#dummy-title-block").show();
                $("#marketplace-icon-block").hide();
                $("#dummy-icon-block").show();
                break;
            case 3:
                $("#form-section-3 button").removeClass("active");
                $("#form-section-2 button div").removeClass("active");
                $("#form-section-2 button")
                    .addClass("active")
                    .removeClass("done");

                this.currentStep = 2;
                this.activeTab();
                this.setButtonText();
                $("#marketplace-description-block").hide();
                $("#description-empty-block").show();
                $("#market-title-block").hide();
                $("#dummy-title-block").show();
                $("#marketplace-icon-block").hide();
                $("#dummy-icon-block").show();
                break;

            default:
                break;
        }
    },

    activeTab: function (step) {
        $(".solution-left .progress-items button").attr(
            "aria-selected",
            "false"
        );
        $(
            ".solution-left .progress-items button:nth-child(" +
                this.currentStep +
                ")"
        ).attr("aria-selected", "true");

        $(".solution-left .tab-content .tab-pane")
            .removeClass("active")
            .removeClass("show");
        $(
            ".solution-left .tab-content .tab-pane:nth-child(" +
                this.currentStep +
                ")"
        )
            .addClass("active")
            .addClass("show");
    },

    setButtonText: function (text) {
        switch (this.currentStep) {
            case 1:
                this.nextButton.querySelector("span").innerText = "Next";
                this.nextButton
                    .querySelector("div.menu28-icon")
                    .classList.remove("d-none");
                break;
            case 2:
                this.nextButton.querySelector("span").innerText = "Next";
                this.nextButton
                    .querySelector("div.menu28-icon")
                    .classList.remove("d-none");
                break;
            case 3:
                this.nextButton.querySelector("span").innerText = "Finish";
                this.nextButton.querySelector("span").classList.add("indent-0");
                this.nextButton
                    .querySelector("div.menu28-icon")
                    .classList.add("d-none");
                break;
            default:
                break;
        }
    },

    showCheckoutDrawer: function () {
        //show offcanvas
        $("div[data-id-solution-drawer]").removeClass("d-none");
        $("div[data-solution-blk]").removeClass("d-none");
        $("div[data-id-access-drawer]").addClass("d-none");
        $("#add-sol-data-access-id").offcanvas("show");

        const addSolutionOffcanvas = document.getElementById(
            "add-sol-data-access-id"
        );
        let footer = addSolutionOffcanvas.querySelector(
            ".common-footer.position-sticky"
        );
        footer
            .querySelector("div[data-color-blue]")
            .classList.remove("green-1");
        footer
            .querySelector("div[data-color-blue]")
            .classList.add("light-blue");
    },
};

ClimateSolution.init();

// Climate Solution Multistep

$(".multileveldropdowntheme").hover(
    function () {
        $(this).addClass("show");
    },
    function () {
        $(this).removeClass("show");
    }
);

// multi-click-chips

$(".dropdown-toggle-parent").on("show.bs.dropdown", function () {
    $(this).parents(".common-shadow").addClass("custom-height");
});

$(".dropdown-toggle-parent").on("hide.bs.dropdown", function () {
    $(this).parents(".common-shadow").removeClass("custom-height");
});

$(".elec-gen-block .read-more").on("click", function () {
    $(".elec-gen-block .custom-list")
        .find("li.lastli-open")
        .removeClass("style-none-li");
    $("this").addClass("style-none-li");
});

$(".adaptation-eff-right .read-more").on("click", function () {
    $(".adaptation-eff-right .elec-gen-block")
        .find(".normal-detailview")
        .toggleClass("d-none");
    $(".adaptation-eff-right .elec-gen-block")
        .find(".common-accordion")
        .toggleClass("h-741");
});

$(".wfall-graph-drop").on("click", function () {
    $(".scriptaddon").toggleClass("topadjst");
});

$(".tooltip2 .info-tooltipbtn").on("click", function () {
    const infoElement = document.querySelectorAll(".info.active-state");
    infoElement.forEach(function (element) {
        element.classList.remove("active-state");
    });
});

$(".tooltip2 .close-tooltip").on("click", function () {
    $(this).parents(".info").removeClass("active-state");
});

// climate-solution

$("#more-solution")
    .on("hide.bs.collapse", function () {
        $(".more-reduction-option").removeClass("tr-more-action");
        $("button[data-bs-target='#more-solution']").blur();
    })
    .on("show.bs.collapse", function () {
        $(".more-reduction-option").addClass("tr-more-action");
    })
    .on("hidden.bs.collapse", function () {
        //check if button is in hover state
        const isHover = $(
            'button[data-bs-target="#more-solution"]:hover'
        ).length;
        if (!isHover) {
            $(".more-reduction-option").css("background-color", "#fff");
        }
    });

$(".more-hover")
    .on("mousemove", function () {
        if ($(this).hasClass("tr-more-action")) {
            $(this).css("background-color", "#E6EFFE");
            //next sibling
            $(this).next().css("background-color", "#E6EFFE");
        } else {
            $(this).css("background-color", "#E6EFFE");
            //next sibling
            $(this).next().css("background-color", "#E6EFFE");
        }
    })
    .on("mouseleave", function () {
        if ($(this).hasClass("tr-more-action")) {
            $(this).css("background-color", "#F2F7FF");
            $(this).next().css("background-color", "#F2F7FF");
        } else {
            $(this).css("background-color", "#FFF");
            $(this).next().css("background-color", "#FFF");
        }
    });

$(".dynamic-data")
    .on("mousemove", function () {
        $(this).css("background-color", "#E6EFFE");
        //previous sibling
        $(this).prev().css("background-color", "#E6EFFE");
    })
    .on("mouseleave", function () {
        $(this).css("background-color", "#F2F7FF");
        $(this).prev().css("background-color", "#F2F7FF");
    });

// info-hover on field

$(document).ready(function () {
    $(".building-popup-box-modal .infoic-graphenergy .tooltip2")
        .on("mouseover click", function (e) {
            $(
                ".building-popup-box-modal .sliderwith-info .energy-graph"
            ).addClass("singlehover");
        })
        .on("mouseout", function (e) {
            $(
                ".building-popup-box-modal .sliderwith-info .energy-graph"
            ).removeClass("singlehover");
        });

    $(".nullable-dropdown")
        .find("li")
        .on("click", function () {
            var text = $(this)
                .find("p")
                .clone()
                .children()
                .remove()
                .end()
                .text()
                .trim()
                .replaceAll(",", "");

            $(this)
                .parent()
                .parent()
                .find("button")
                .find("label")
                .css("top", "-16px")
                .css("transition", "all 0.1s ease-in-out")
                .css("font-size", "12px");
            $(this)
                .parent()
                .parent()
                .find("button")
                .find("label")
                .addClass("block-priority");
        });
    $(".nullable-dropdown").find("button").find("p").text("");
    $(".nullable-dropdown").find("li").find("a").removeClass("active");

    $(".float-dropfixed.nullable-dropdown")
        .find("li")
        .on("click", function () {
            var text = $(this)
                .find("p")
                .clone()
                .children()
                .remove()
                .end()
                .text()
                .trim()
                .replaceAll(",", "");

            $(this)
                .parent()
                .parent()
                .find("button")
                .find("label")
                .css("top", "-11px")
                .css("transition", "all 0.1s ease-in-out")
                .css("font-size", "12px");
            $(this)
                .parent()
                .parent()
                .find("button")
                .find("label")
                .addClass("block-priority");
        });
    $(".float-dropfixed.nullable-dropdown").find("button").find("p").text("");
    $(".float-dropfixed.nullable-dropdown")
        .find("li")
        .find("a")
        .removeClass("active");

    //Remove double layer offbackdrop  modal and offcanvas
    $("#climate-solution-report #cli-sol-buy").on("click", function () {
        if ($("#climate-solution-report").hasClass("show")) {
            $("#offsetEmission")
                .on("show.bs.offcanvas", function () {
                    // $(".modal-backdrop.show").addClass("no-backdrop");
                    // $(".modal-backdrop.show").removeClass("show");
                    $(".modal-backdrop.show").addClass("opacity-0");
                })
                .on("hide.bs.offcanvas", function () {
                    // $(".modal-backdrop").addClass("show");
                    // $(".modal-backdrop.show").removeClass("d-none");
                });
        }
    });

    $("#offsetEmission").on("show.bs.offcanvas", function () {
        $(".modal-backdrop.show").addClass("opacity-0");
        $("div[data-access-footer]").removeClass("opacity-0");
    });

    $("#offsetEmission").on("hide.bs.offcanvas", function () {
        $(".modal-backdrop.show").removeClass("opacity-0");
    });
});

$(".offset-emission-drawer .homeadd-vehicle .homehover .edit-input")
    .on("mouseover click", function (e) {
        $(".offset-emission-drawer .homehover input").addClass("sibling-hover");
    })
    .on("mouseout", function (e) {
        $(".offset-emission-drawer .homehover input").removeClass(
            "sibling-hover"
        );
    });

$(".offset-emission-drawer .homeadd-vehicle .vehicleno .edit-input")
    .on("mouseover click", function (e) {
        $(".offset-emission-drawer .vehicleno input").addClass("sibling-hover");
    })
    .on("mouseout", function (e) {
        $(".offset-emission-drawer .vehicleno input").removeClass(
            "sibling-hover"
        );
    });

$(".complex-select button")
    .on("focus", function () {
        $(this).parent().addClass("z-indx2");
    })
    .on("blur", function () {
        $(this).parent().removeClass("z-indx2");
    });

$(".two-part-complex button, .two-part-complex input")
    .on("focus", function () {
        $(this).parent().addClass("z-indx2");
    })
    .on("blur", function () {
        $(this).parent().removeClass("z-indx2");
    });

$(" .two-part-complex-input-drop input, .two-part-complex-input-drop button")
    .on("focus", function () {
        $(this).parent().addClass("z-indx4");
    })
    .on("blur", function () {
        $(this).parent().removeClass("z-indx4");
    });

$(".icon-drop-input-component .input-search input")
    .on("focus", function () {
        $(this).closest(".input-search").addClass("z-indx2");
    })
    .on("blur", function () {
        $(this).closest(".input-search").removeClass("z-indx2");
    });
$(".withouticon-drop-input-component .input-search input")
    .on("focus", function () {
        $(this).closest(".input-search").addClass("z-indx2");
    })
    .on("blur", function () {
        $(this).closest(".input-search").removeClass("z-indx2");
    });

$(".complex-input input")
    .on("focus", function () {
        $(this).closest(".complex-input").addClass("z-indx2");
    })
    .on("blur", function () {
        $(this).closest(".complex-input").removeClass("z-indx2");
    });

$("#adaptation-detail-popup .card-footer #dropdownMenuButton2")
    .on("focus", function () {
        $(this).closest(".card-footer").addClass("z-indx2");
    })
    .on("blur", function () {
        $(this).closest(".card-footer").removeClass("z-indx2");
    });

$(".Inc-percent-kwh .complex-select button")
    .on("focus", function () {
        $(this).parent().addClass("z-indx2");
    })
    .on("blur", function () {
        $(this).parent().removeClass("z-indx2");
    });

$(".Inc-percent-kwh .complex-input input")
    .on("focus", function () {
        $(this).closest(".complex-input").addClass("z-indx2");
    })
    .on("blur", function () {
        $(this).closest(".complex-input").removeClass("z-indx2");
    });

$(".value-percentage")
    .on("focus", function () {
        $(this)
            .parents(".complex-input")
            .find(".set-div")
            .addClass("parent-highlight");
    })

    .on("blur", function () {
        $(this)
            .parents(".complex-input")
            .find(".set-div")
            .removeClass("parent-highlight");
    });
var greenValue = document.querySelector(".percent-green");
greenValue.addEventListener("click", function () {
    document.querySelector(".value-percentage").focus();
});

$(".wf-btn").on("click", function () {
    $(".waterfall-wrapper").toggleClass("height313");
});
$(".climate-report .edit-data-btn").on("click", function () {
    $(".consumption-popup-modal").addClass("background-toggle");
});
$(".close-icon-right").on("click", function () {
    $(".consumption-popup-modal").removeClass("background-toggle");
});
$(".controlers a").focus(function (event) {
    event.target.blur();
});

$(".graph-btn").on("click", function () {
    $(".graph-btn").addClass("color-added");
});

$(".consumption-graph .close-icon-right a").on("click", function () {
    $(".graph-btn").removeClass("color-added");
});

const companyLists = document.querySelectorAll("[data-company-list]");
companyLists.forEach((companyList) => {
    companyList.addEventListener("click", () => {
        const logo = companyList.querySelector("[data-company-logo]").src;
        const name = companyList.querySelector("[data-company-name]").innerText;

        document.querySelector("[data-bank-name-icon]").src = logo;
        document.querySelector("[data-bank-name-header]").innerText = name;
        $("#integrate-drawer").offcanvas("show");
        //set attribute to login button
        $("#integration-login").attr("data-clicked-company-name", name);
    });
});

$("#integration-login").on("click", function () {
    $("#success-mes-intigrate").removeClass("d-none");
    setTimeout(() => {
        //get clicked company name attribute
        let company_name = $("#integration-login").attr(
            "data-clicked-company-name"
        );
        const clickedCompany = document.querySelector([
            '[data-company-list="' + company_name + '"]',
        ]);
        clickedCompany.classList.add("active");

        $("#integrate-drawer").offcanvas("hide");
    }, 500);
});

$(".search-drop-element .search-section input")
    .on("focus", function () {
        $(this).parents(".search-drop-element").addClass("child-focus-addon");
    })
    .on("blur", function () {
        $(this)
            .parents(".search-drop-element")
            .removeClass("child-focus-addon");
    });

let short_input = document.querySelectorAll(".short-input");

short_input.forEach((element) => {
    $(element).on("focus", () => {
        element.closest(".duo-input").classList.add("activated");
    });
    $(element).on("blur", () => {
        element.closest(".duo-input").classList.remove("activated");
    });
});

let nav_items = document.getElementsByClassName("small-tabs");

$(".car-search input").on("input", function () {
    if (!this.value) {
        $(this).closest(".form-control-placeholder").removeClass("has-value");
    } else {
        $(this).closest(".form-control-placeholder").addClass("has-value");
    }
});

$(".dayinput").on("keypress", function (e) {
    let currentValue = String.fromCharCode(e.which);
    let finalValue = $(this).val() + currentValue;
    if (finalValue > 7) {
        e.preventDefault();
    }
});
$(".weekinput").on("keypress", function (e) {
    let currentValue = String.fromCharCode(e.which);
    let finalValue = $(this).val() + currentValue;
    if (finalValue > 52) {
        e.preventDefault();
    }
});

$(".driving-table .input-percent").on("keypress", function (e) {
    var currentValue = String.fromCharCode(e.which);
    var finalValue = $(this).val() + currentValue;
    if (finalValue > 100) {
        e.preventDefault();
    }
});

$(
    ".energy-table-data .energy-graph, .slider-multiple-input .left-input-slider, .slider-multiple-input .right-input-slider, .consmptn-table-value .energy-graph, .input-dollar .energy-graph, .percent-maxlength .energy-graph, .card-pagination .energy-graph"
).on("click", function () {
    let value = $(this).find("input").val();
    $(this).find("input").focus().val(value);
});

$(".duo-input .first-input, .duo-input .second-input").on("click", function () {
    let value = $(this).find("input").val();
    $(this).find("input").focus().val(value);
});

let side_list = document
    .getElementById("assets_menu")
    .querySelectorAll(".assets_list");
side_list.forEach((el) => {
    el.addEventListener("click", function () {
        let active_list = document.querySelectorAll(".assets_list.active");
        for (let ac = 0; ac < active_list.length; ac++) {
            active_list[ac].classList.remove("active");
        }
        el.classList.add("active");
    });
});

let vehicle_tab = document.getElementById("vehicleTable_tab");
let facility_tab = document.getElementById("facilityTable_tab");
let facilites_section = document.querySelector(".assets-facilites");
let vehicles_section = document.querySelector(".assets-vehicles");

vehicle_tab?.addEventListener("click", function () {
    facilites_section.classList.add("d-none");
    vehicles_section.classList.remove("d-none");
});

facility_tab?.addEventListener("click", function () {
    facilites_section.classList.remove("d-none");
    vehicles_section.classList.add("d-none");
});

// driving pattern flow

let consumptionDrivingDefault = document.querySelector(".driving-content");
let consumptionDrivingTable = document.querySelector(".driving-table");
let drivingDataDefaultTable = document.querySelector(".driving-default-table");
let consumptionTransoReset = document.querySelector(
    ".consumption-transo-footer .reset-btn"
);
let consumptionGetHelp = document.querySelector(".get-help");
let consumptionTransoSeparator = document.querySelector(
    ".consumption-transo-footer .separator-cons-footer"
);
let drivingDataApplyBtn = document.querySelector(".driving-data .btn-apply");
let drivingDataInput = document.querySelectorAll(".driving-data input");
let drivingDataYearDrop = document.querySelectorAll(
    ".driving-data .searchbtn-year .dropdown-item"
);
let getHelpSec = document.querySelector(".consumption-transo-footer .get-help");
let transpoFooterNext = document.querySelector(
    ".consumption-transo-footer .consumption-next-btn"
);

drivingDataApplyBtn?.addEventListener("click", function () {
    consumptionDrivingDefault.classList.add("d-none");
    drivingDataDefaultTable.classList.remove("d-none");
    consumptionTransoReset.classList.remove("d-none");
    getHelpSec.classList.add("shrink-div");
    TransEditConsumptionFlow.showResetButton = true;
});
drivingDataDefaultTable?.addEventListener("click", function () {
    drivingDataDefaultTable.classList.add("d-none");
    consumptionDrivingTable.classList.remove("d-none");
});

drivingDataYearDrop?.forEach((element) => {
    $(element).on("click", () => {
        drivingDataApplyBtn.classList.remove("disabled");
    });
});

// get all the li with data-initials attribute and loop through them
let annualMilesDrivenFieldOptions =
    document.querySelectorAll("[data-initials]");

// loop through each li and add click event listener
annualMilesDrivenFieldOptions?.forEach(function (option) {
    // on click of each li element get the data-initials attribute value and set it as the text of the button
    option.addEventListener("click", function () {
        let initial = this.getAttribute("data-initials");
        let button = this.closest("ul");
        button = $(button)
            .siblings("button")
            .children("p.align-items-center")
            .children("p")
            .text(initial);
    });
});

// Radio Tab Switcher

// var energyCheck = document.querySelectorAll(".climateEnergy");
// var emissionCheck = document.querySelectorAll(".climateEmission");
// var emissionSwitcher = document.querySelectorAll(".emission-switch");
// var energySwitcher = document.querySelectorAll(".energy-switch");
// var lineChart = document.querySelector(".electrification-lineChart");
// var eleWaterfall = document.querySelector(".electrification-waterfall");
// var meterBlockTab = document.querySelector(".meter-block");

// for (let j = 0; j < energyCheck.length; j++) {
//     energyCheck[j].addEventListener("change", (e) => {
//         if (e.target.checked === true) {
//             emissionSwitcher.forEach((forRev) => {
//                 forRev.classList.add("d-none");
//             });
//             energySwitcher.forEach((forEnergy) => {
//                 forEnergy.classList.remove("d-none");
//             });
//             lineChart.classList.remove("d-none");
//             eleWaterfall.classList.add("d-none");
//             meterBlockTab.classList.remove("d-none");
//         }
//     });
// }

// for (let k = 0; k < emissionCheck.length; k++) {
//     emissionCheck[k].addEventListener("change", (e) => {
//         if (e.target.checked === true) {
//             emissionSwitcher.forEach((rev) => {
//                 rev.classList.remove("d-none");
//             });
//             energySwitcher.forEach((revEnergy) => {
//                 revEnergy.classList.add("d-none");
//             });
//             lineChart.classList.add("d-none");
//             eleWaterfall.classList.remove("d-none");
//             meterBlockTab.classList.add("d-none");
//         }
//     });
// }

// var supplyActive = document.getElementById("facility-supply-tab");
// var electrificationActive = document.getElementById(
//     "facility-electrification-tab"
// );
// var efficiencyActive = document.getElementById("facility-efficiency-tab");
// var offsetActive = document.getElementById("facility-offsets-tab");
// var marginalActive = document.querySelector(".marginal-switch");

// supplyActive?.addEventListener("click", function () {
//     if (this.classList.contains("active")) {
//         marginalActive.classList.remove("d-none");
//         document.querySelector("[ifSupply1]").classList.add("d-none");
//     } else {
//         document.querySelector("[ifSupply1]").classList.remove("d-none");
//     }
// });

// electrificationActive?.addEventListener("click", function () {
//     if (this.classList.contains("active")) {
//         marginalActive.classList.add("d-none");
//     }
// });

// efficiencyActive?.addEventListener("click", function () {
//     if (this.classList.contains("active")) {
//         marginalActive.classList.add("d-none");
//     }
// });

// offsetActive?.addEventListener("click", function () {
//     if (this.classList.contains("active")) {
//         marginalActive.classList.add("d-none");
//     }
// });
// Radio Tab Switcher End

// Graph file type download Start

function xlsx_download() {
    let xlsx_btn = document.querySelectorAll("[btn_xlsx]");
    xlsx_btn.forEach((xlsx) => {
        if (xlsx.classList.contains("active")) {
            climateReport_xlsx();
        }
    });
}

function png_download() {
    let png_btn = document.querySelectorAll("[btn_png]");
    png_btn.forEach((png) => {
        if (png.classList.contains("active")) {
            climateReport_png();
        }
    });
}

function pdf_download() {
    let pdf_btn = document.querySelectorAll("[btn_pdf]");
    pdf_btn.forEach((pdf) => {
        if (pdf.classList.contains("active")) {
            climateReport_pdf();
        }
    });
}
var downloadbtn = document.querySelectorAll("[report_downloader]");
downloadbtn.forEach((downloader) => {
    downloader.addEventListener("click", function () {
        xlsx_download();
        png_download();
        pdf_download();
    });
});
// Graph download End

var switcher = document.querySelectorAll(".switcher");

switcher.forEach((mark) => {
    mark.addEventListener("click", function () {
        this.classList.toggle("active");
    });
});

// timeframe clear
$(".timeframe-info .clear-cross").on("click", function () {
    $("input.full-timeframe").val("");
    $(".timeframe-hifon").removeClass("d-none");
});
$("input.full-timeframe").on("keyup", function () {
    if ($(this).val() != "") {
        $(".timeframe-hifon").addClass("d-none");
        $(".timeframe-info .clear-cross .clear-ic").removeClass("d-none");
        $(".timeframe-info .clear-cross .calender-ic-src").addClass("d-none");
    } else {
        $(".timeframe-hifon").removeClass("d-none");
        $(".timeframe-info .clear-cross .clear-ic").addClass("d-none");
        $(".timeframe-info .clear-cross .calender-ic-src").removeClass(
            "d-none"
        );
    }
});

$(".timeframe-info .clear-cross .clear-ic").on("click", function () {
    $(this).addClass("d-none");
    $(".timeframe-info .clear-cross .calender-ic-src").removeClass("d-none");
});

$(".end-use-dropdown ul.dropdown-menu .accordion-button").on(
    "click",
    function (event) {
        event.stopPropagation();
    }
);

$("div[impactcard] .carousel-item, .map-eff-left .carousel-item").on(
    "click",
    function () {
        $(this).toggleClass("selected-solution");
    }
);
$(
    ".right-col-webapp .checkout-solution-dropdown, .right-col-webapp .slider-info, .right-col-webapp .slider-logo"
).on("click", function (event) {
    event.stopPropagation();
});

$("#optioncarouselIndicators4").on("slid.bs.carousel", function () {
    if ($(".carousel-item.active").hasClass("selected-solution")) {
        $("div.option-impactcard").addClass("cardImpacted");
    } else {
        $("div.option-impactcard").removeClass("cardImpacted");
    }
});

$("#facility-carousel-right-blk").on("slid.bs.carousel", function () {
    if ($(".carousel-item.active").hasClass("selected-solution")) {
        $("div[impactcard]").addClass("cardImpacted");
    } else {
        $("div[impactcard]").removeClass("cardImpacted");
    }
});

$("a[seeimpact]").on("click", function () {
    $(this).closest("div[impactcard]").toggleClass("cardImpacted");
});
$(".option-map-seeimpact, .option-impactcard .card-body ").on(
    "click",
    function () {
        $(".option-impactcard").toggleClass("cardImpacted");
        $(".option-map-seeimpact").toggleClass("focus-btn-default");
    }
);
$(".option-map-seeimpact").on("click", function () {
    if ($(".option-map-seeimpact").hasClass("focus-btn-default")) {
        $(this).toggleClass("focus-btn-default");
    }
});

$(
    ".option-impactcard .card-footer button, .option-impactcard #identifiedtext, .option-impactcard .read-more, .option-impactcard .card-img img, .option-impactcard .card-titlename, .option-impactcard .description-block p, .option-impactcard .description-block, .option-impactcard .dismiss-read-more"
).on("click", function (stopevent) {
    stopevent.stopPropagation();
});

$(
    ".explore-options-modal .card-header .nav-link, .main-content-map .block-switch .carousel-control-prev, .main-content-map .block-switch .carousel-control-prev-icon"
).on("click", function () {
    $(".option-impactcard").removeClass("cardImpacted");
});

$("div[impactcard] .slider-content").on("click", function () {
    $(this).closest("div[impactcard]").toggleClass("cardImpacted");
});
$(
    ".right-col-webapp .add-solution-data-access .sub-prev-btn-set, .right-col-webapp .add-solution-data-access .sub-next-btn-set"
).on("click", function () {
    $("div[impactcard]").removeClass("cardImpacted");
});
$("div[impactcard] .slider-footer .tag-line").on("click", function () {
    $(this).closest("div[impactcard]").toggleClass("cardImpacted");
});

$("div[impactcard] .slider-logo, div[impactcard] .slider-info h5").on(
    "click",
    function () {
        $("div[impactcard]").addClass("shadow-blank");
    }
);

$("#facilityclimate-solutionreportpop").on("hide.bs.modal", function () {
    $("div[impactcard]").removeClass("shadow-blank cardImpacted");
});

// radio-toggle-checked

const radios = document.querySelectorAll("[data-checked]");
radios.forEach((item) => {
    item.addEventListener("click", function () {
        $("[data-checked]").not(this).attr("data-checked", 0);
        const yy = $(item).attr("data-checked");
        if (yy == 1) {
            $(item).prop("checked", false);
            $(item).attr("data-checked", 0);
            $(item).blur();
        } else {
            $(item).prop("checked", true);
            $(item).attr("data-checked", 1);
        }
    });
});

$("#desc-extraone").on("show.bs.collapse", function () {
    $(".map-eff-left .carousel-item").addClass("bg-white");
});

$("#desc-extraone").on("hidden.bs.collapse", function () {
    $(".map-eff-left .carousel-item").removeClass("bg-white");
});

$(".geography-input .input-search input").on("keyup", function () {
    if ($(this).val().length) {
        $(".geography-input .address-list").removeClass("d-none");
        $(".geography-input .clear-cross").removeClass("d-none");
    } else {
        $(".geography-input .address-list").addClass("d-none");
        $(".geography-input .clear-cross").addClass("d-none");
    }
});

$(".geography-input .clear-cross").on("click", function () {
    $(this).addClass("d-none");
    $(".geography-input .input-search input").val("");
    $(".geography-input .address-list").addClass("d-none");
});

var consumptionEnterUsage = document.querySelector(
    '.consumptionpop_eusage button[data-bs-toggle="tab"]'
);
var consumptionPopBody = document.querySelector(".consumptionpopup-body");
var consumptionResiTabButton = document.querySelector(
    ".consumption-resi-tabclass"
);
var consumptionTranspoTabButton = document.querySelector(
    ".consumption-transpo-tabclass"
);

consumptionEnterUsage?.addEventListener("show.bs.tab", function () {
    consumptionPopBody.classList.add("overflow-visible");
});
consumptionEnterUsage?.addEventListener("hide.bs.tab", function () {
    consumptionPopBody.classList.remove("overflow-visible");
});
consumptionResiTabButton?.addEventListener("hide.bs.tab", function () {
    consumptionPopBody.classList.remove("overflow-visible");
});
consumptionTranspoTabButton?.addEventListener("hide.bs.tab", function () {
    consumptionPopBody.classList.remove("overflow-visible");
});

// Add climate parameters switch

var energyEffParameter = document.querySelector(
    "a[energy-efficient-parameter]"
);
var electrificationParameter = document.querySelector(
    "a[electrification-parameter]"
);
var fuelSwitchingParameter = document.querySelector(
    "a[fuel-switching-parameter]"
);
var supplyChangeParameter = document.querySelector("a[supplychange-parameter]");
var energyEffParameterDiv = document.querySelector(
    ".energyefficiency-parameters"
);
var electrificationParameterDiv = document.querySelector(
    ".electrification-parameters"
);
var fuelSwitchingParameterDiv = document.querySelector(
    ".fuelswitching-parameters"
);

var supplyChangeParameterDiv = document.querySelector(
    ".supplychange-parameters"
);

energyEffParameter.addEventListener("click", function () {
    // alert("fddf");
    energyEffParameterDiv.classList.remove("d-none");
    fuelSwitchingParameterDiv.classList.add("d-none");
    supplyChangeParameterDiv.classList.add("d-none");
    electrificationParameterDiv.classList.add("d-none");
});
electrificationParameter.addEventListener("click", function () {
    energyEffParameterDiv.classList.add("d-none");
    fuelSwitchingParameterDiv.classList.add("d-none");
    supplyChangeParameterDiv.classList.add("d-none");
    electrificationParameterDiv.classList.remove("d-none");
});
fuelSwitchingParameter.addEventListener("click", function () {
    energyEffParameterDiv.classList.add("d-none");
    electrificationParameterDiv.classList.add("d-none");
    supplyChangeParameterDiv.classList.add("d-none");
    fuelSwitchingParameterDiv.classList.remove("d-none");
});
supplyChangeParameter.addEventListener("click", function () {
    energyEffParameterDiv.classList.add("d-none");
    electrificationParameterDiv.classList.add("d-none");
    fuelSwitchingParameterDiv.classList.add("d-none");
    supplyChangeParameterDiv.classList.remove("d-none");
});

// button-with-right-drop

$(".button_with_rightblk_dropdown .leftblk_arrowbutton button").on(
    "mouseenter",
    function () {
        $(
            ".button_with_rightblk_dropdown .actionbutton_rightblk button"
        ).addClass("hover-filled");
    }
),
    $(".button_with_rightblk_dropdown .leftblk_arrowbutton button").on(
        "mouseleave",
        function () {
            $(
                ".button_with_rightblk_dropdown .actionbutton_rightblk button"
            ).removeClass("hover-filled");
        }
    );

$(".button_with_rightblk_dropdown .leftblk_arrowbutton button").on(
    "mouseup",
    function () {
        $(
            ".button_with_rightblk_dropdown .actionbutton_rightblk button"
        ).removeClass("mousedown-filled");
    }
),
    $(".button_with_rightblk_dropdown .leftblk_arrowbutton button").on(
        "mousedown",
        function () {
            $(
                ".button_with_rightblk_dropdown .actionbutton_rightblk button"
            ).addClass("mousedown-filled");
        }
    );

$("#climate-solution").on("shown.bs.modal", function (e) {
    $("body").addClass("datepickerclimatereport");
});
$("#climate-solution").on("hidden.bs.modal", function (e) {
    $("body").removeClass("datepickerclimatereport");
});
